import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.search";
import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import s from "clsx";
import e, { useEffect as d, useState as r } from "react";
import { ArrowRight as N, CheckCircle as A } from "@hagerty/icons";
import P from "react-google-recaptcha";

var L = "00D1I0000002QcJ",
    U = "00D530000004jc6",
    D = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
    H = "https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
    k = "6LdDYdoaAAAAAF4l8rDntJH_qfonDBodR5x7YzBN",
    J = function J(_ref) {
  var _ref$campaignId = _ref.campaignId,
      u = _ref$campaignId === void 0 ? "7011I000000CD7OQAW" : _ref$campaignId,
      _ref$isProd = _ref.isProd,
      l = _ref$isProd === void 0 ? !0 : _ref$isProd,
      _ref$isSubmitted = _ref.isSubmitted,
      f = _ref$isSubmitted === void 0 ? !1 : _ref$isSubmitted;

  var g = l ? D : H,
      i = l ? L : U,
      _r = r(""),
      _r2 = _slicedToArray(_r, 2),
      p = _r2[0],
      h = _r2[1],
      _r3 = r(f),
      _r4 = _slicedToArray(_r3, 2),
      b = _r4[0],
      _ = _r4[1],
      m = e.useRef(null),
      n = e.useRef(null),
      _r5 = r(""),
      _r6 = _slicedToArray(_r5, 2),
      c = _r6[0],
      w = _r6[1],
      _r7 = r(""),
      _r8 = _slicedToArray(_r7, 2),
      v = _r8[0],
      y = _r8[1],
      C = function C(t) {
    w(t.target.value);
  },
      S = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
      var a;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(t.preventDefault(), n.current)) {
                _context.next = 15;
                break;
              }

              y(JSON.stringify({
                keyname: "RecaptchaV3",
                fallback: "true",
                orgId: i,
                ts: JSON.stringify(new Date().getTime())
              }));
              _context.prev = 2;
              _context.next = 5;
              return n.current.executeAsync();

            case 5:
              if (!_context.sent) {
                _context.next = 9;
                break;
              }

              (a = m.current) == null || a.submit();
              _context.next = 10;
              break;

            case 9:
              console.error("Failed to get reCAPTCHA token");

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              console.error("reCAPTCHA execution failed:", _context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));

    return function S(_x) {
      return _ref2.apply(this, arguments);
    };
  }(),
      T = function T(t) {
    var o;
    return (o = new URLSearchParams(window.location.search).get(t)) != null ? o : "";
  };

  return d(function () {
    var t = new URL(window.location.href);
    t.searchParams.set("StatusCode", "Success"), h(t.toString());
  }, []), d(function () {
    T("StatusCode") === "Success" && _(!0);
  }, []), e.createElement("div", {
    className: "hg-global-footer__newsletter"
  }, e.createElement("h4", {
    className: "hg-global-footer__newsletter-heading"
  }, "Newsletter"), e.createElement("p", {
    className: "hg-global-footer__newsletter-subhead"
  }, "Stay up to date on the latest news."), b ? e.createElement("form", {
    className: s("hg-global-footer__newsletter-form", "submitted")
  }, e.createElement("input", {
    disabled: !0,
    className: s("hg-global-footer__newsletter-form-input", "submitted"),
    name: "success",
    value: "You're signed up!"
  }), e.createElement("div", {
    className: s("hg-global-footer__newsletter-form-icon", "submitted")
  }, e.createElement(A, null))) : e.createElement("form", {
    className: "hg-global-footer__newsletter-form",
    id: "globalfooter-newsletter-form",
    name: "globalfooter-newsletter-form",
    method: "POST",
    action: g,
    ref: m,
    onSubmit: S
  }, e.createElement("input", {
    type: "hidden",
    name: "oid",
    value: i
  }), e.createElement("input", {
    type: "hidden",
    name: "lead_source",
    value: "Website"
  }), e.createElement("input", {
    type: "hidden",
    name: "Other_Source__c",
    value: "Global Footer"
  }), e.createElement("input", {
    type: "hidden",
    name: "Campaign_ID",
    value: u
  }), e.createElement("input", {
    type: "hidden",
    name: "Subscriptions__c",
    value: "Weekend Road Trip"
  }), e.createElement("input", {
    type: "hidden",
    name: "captcha_settings",
    value: v
  }), e.createElement("input", {
    type: "hidden",
    id: "newsletter-signup-globalfooter_formReturnURL",
    name: "retURL",
    value: p
  }), e.createElement("input", {
    className: "hg-global-footer__newsletter-form-input",
    id: "email",
    name: "email",
    type: "email",
    placeholder: "Email address",
    value: c,
    onChange: C
  }), e.createElement("div", {
    className: "hg-global-footer__newsletter-form-icon"
  }, e.createElement("button", {
    type: "submit",
    "aria-label": "Submit Newsletter sign up",
    className: s("hg-global-footer__newsletter-submit", "g-recaptcha"),
    disabled: !c
  }, e.createElement(N, null))), e.createElement(P, {
    ref: n,
    sitekey: k,
    size: "invisible"
  })), e.createElement("p", {
    className: "hg-global-footer__newsletter-disclaimer"
  }, "This site is protected by reCAPTCHA and the Google", " ", e.createElement("a", {
    href: "https://policies.google.com/privacy"
  }, "Privacy Policy"), " and", " ", e.createElement("a", {
    href: "https://policies.google.com/terms"
  }, "Terms and Conditions"), "."));
};

export { J as Newsletter };